export const gradeList = ['L1', 'L2', 'L3', 'L4', 'L5', 'L6', 'L7', 'L8', 'na'];